/**
 * Newsletter subscribe form (F100.1)
 *
 * Posts to /api/subscribe. Includes the honeypot field ("website") that real
 * users never see or fill. Copy follows the site voice rules: plain promise,
 * no spam, no schedule, no job-search language.
 */

import React, { useState } from 'react';

const SubscribeForm = () => {
  const [email, setEmail] = useState('');
  const [website, setWebsite] = useState(''); // honeypot
  const [state, setState] = useState('idle'); // idle | loading | done | error
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState('loading');
    setError('');
    try {
      const resp = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim(),
          website: website || null,
          page: typeof window !== 'undefined' ? window.location.pathname : null,
        }),
      });
      if (resp.status === 422) {
        setState('error');
        setError('Please enter a valid email.');
        return;
      }
      if (!resp.ok) throw new Error('subscribe failed');
      setState('done');
    } catch (err) {
      setState('error');
      setError('Something went wrong. Please try again.');
    }
  };

  if (state === 'done') {
    return (
      <div className="max-w-md mx-auto text-center py-4">
        <p className="text-slate-700 dark:text-slate-200 font-medium">You're in. Vibe code and Prosper 🖖</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="max-w-md mx-auto text-center">
      <p className="text-sm text-slate-600 dark:text-slate-300 mb-3">
        New posts and product demos, straight to your inbox. No spam, no schedule.
      </p>
      <div className="flex gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="flex-1 min-w-0 px-4 py-2.5 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 text-sm focus:border-sky-500 focus:ring-1 focus:ring-sky-500 outline-none transition-colors"
        />
        {/* Honeypot: hidden from real users, tempting to bots */}
        <input
          type="text"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          className="hidden"
          name="website"
          placeholder="Your website"
        />
        <button
          type="submit"
          disabled={state === 'loading'}
          className="px-5 py-2.5 bg-sky-600 hover:bg-sky-700 disabled:opacity-60 text-white text-sm font-medium rounded-lg transition-colors shrink-0"
        >
          {state === 'loading' ? 'Subscribing...' : 'Subscribe'}
        </button>
      </div>
      {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
    </form>
  );
};

export default SubscribeForm;
